import React from 'react';
import { observer } from 'mobx-react';

// Helpers
import { feeCurrencyFormatter, toHours } from '../../helpers/helpers.js';

// Translations
import translate from '../Translate.js';

// Dependencies
import moment from 'moment';

// Components
import * as icons from '../Icons/Icons';

const ScheduleTable = observer(class ScheduleTable extends React.Component {
  constructor() {
    super();
    this.refreshSchedule = this.refreshSchedule.bind(this);
  }

  componentWillMount() {
    const { ScheduleStore } = this.props.store;

    this.state = {
      time: null,
      examSid: null,
      key: new Date().getTime()
    }

    if(!this.props.reschedule && !this.props.skipUrl) {
      this.setState({
        examSid: this.props.getSid(2)
      })
    } else {
      this.setState({
        examSid: this.props.examSid
      })
    }

    // Get availability
    if(!ScheduleStore.onlineAvailability) {
      const _this = this;

      setTimeout(function(){
        ScheduleStore.getOnlineAvailability(_this.state.examSid, _this.props.sessionSid, this.props.combined);
      });
    }
  }

  renderFeeInformation = (slot) => {
    const { userTimezone } = this.props.store.SessionStore;
    const { translation } = this.props;
    let schedulingRuleInfo = [];

    // If we have scheduling rules set them to our variable
    if (slot.data && slot.data.feeInformation && slot.data.feeInformation.schedulingRuleInformation && slot.data.feeInformation.schedulingRuleInformation) {
      schedulingRuleInfo = slot.data.feeInformation.schedulingRuleInformation;
    }

    // Don't add anything to DOM if no rules are present
    if (schedulingRuleInfo.length === 0) {
      return null;
    }

    return (
      <div className={`fee_information`}>
        <div className='fee__rules'>
          {schedulingRuleInfo.map(
            (item, index) => (item.isShownOnSchedulingCard &&
              <div>
                {index > 0 && <b className='bullet'>{'●'}</b>}
                <div className="tooltip">
                  <span className="tooltip__label info">
                    {item.name}
                  </span>
                  <span className="tooltip__body" role="tooltip">
                    {item.ruleDescription}
                  </span>
                </div>
              </div>
            ))}
        </div>
        {slot.data && slot.data.dateUntil &&
        <div className='date__increase'>
          {moment().diff(moment(slot.data.dateUntil), 'hours') < 48 && slot.data.dateUntil &&
          <h6 className='total__header'> {moment(slot.data.dateUntil).tz(userTimezone).format(`[${translation.premiumSchedulingFeeText.increase}] dddd [${translation.premiumSchedulingFeeText.at}] h:mm A z [${translation.premiumSchedulingFeeText.to} ${feeCurrencyFormatter(slot.data.dateUntilAmount, slot.data.feeInformation.currencyCode)}.]`)}</h6>
          }
        </div>
        }
      </div>
    )
  }
  selectSlotHybrid = (startTime, endTime, slotData) => {
    const { parent, setSlot, setStep, step } = this.props;

    parent.setState({
      startTime
    });

    // TODO: when the API returns the scheduling module (aka when RB is allowed in the tiering) we can no longer
    //  hardcode the scheduling module to set slot, but grab it from the slot
    setSlot(startTime, endTime, slotData.proctorLocationSid, 'smarter-scheduling', slotData.calendarSid, slotData.feeInformation);

    setStep(null, step + 1 || 4);
  }

  selectSlot = (startTime, endTime, proctorLocationSid, schedulingModule) => {
    // Note: We are currently pass the first
    // proctorLocationSid from the array returned
    // by the API for availability.

    const { parent, setSlot, setStep, step } = this.props;

    parent.setState({
      startTime
    });

    setSlot(startTime, endTime, proctorLocationSid, schedulingModule);

    setStep(null, step + 1 || 4);
  }

  statusClass(time) {
    if(this.props.parent.state.time === time) {
      return 'selected';
    } else {
      return '';
    }
  }

  refreshSchedule() {
    const { ScheduleStore } = this.props.store;

    ScheduleStore.getOnlineAvailability(this.state.examSid, this.props.sessionSid, this.props.combined);
  }

  render() {
    const { store, translation } = this.props;
    const { ProctorStore, ScheduleStore, SessionStore } = store;
    const { onlineTimeGroups, onlineTimeRange } = ScheduleStore;
    const { userTimezone } = this.props.store.SessionStore;

    const _this = this;

    if(!SessionStore.backgroundLoading) {
      if(onlineTimeGroups) {
        return(
          <div className={this.props.className}>
            <p className="note note--prominent">
              <strong>{translation.note.heading} </strong>
              {ScheduleStore.examDuration >= 60 &&
                <span>{translation.note.body.replace('%duration%', toHours(ScheduleStore.examDuration, false, true, true))}</span>
              }
              {ScheduleStore.examDuration < 60 &&
                <span>{translation.note.body.replace('%duration%', `${ScheduleStore.examDuration} minutes`)}</span>
              }
            </p>

            {Object.keys(onlineTimeGroups).map(
              (group, i) =>
              <div key={i}>
                {((!onlineTimeRange && onlineTimeGroups[group].morning.length > 0) || onlineTimeRange === 'morning') &&
                  <section className="panel__section block">
                    <h3 className="block__title">{translation.morning}</h3>

                    {onlineTimeGroups[group].morning.length > 0 &&
                      <ul key={i} className="block-list block-list--alt">
                        {onlineTimeGroups[group].morning.map(
                          (slot, j) =>
                            <div>
                              <li key={j} className={`block media--alt space__between ${slot.data && slot.data.feeInformation && slot.data.feeInformation.schedulingRuleInformation && slot.data.feeInformation.schedulingRuleInformation.length > 0 ? 'wrap ' : ''}`}>
                                <div className='schedule_main'>
                                  <div className='schedule_details'>
                                    <h4
                                      className={`block__title--alt ${moment(slot.startDate).tz(userTimezone).format('H') < 5 ? 'negative--alt' : ''}`}
                                    >
                                      {moment(slot.startDate).tz(userTimezone).format('h:mma')}–{moment(slot.startDate).add(ScheduleStore.examDuration, 'minutes').tz(userTimezone).format('h:mma z')}
                                      {moment(slot.startDate).tz(userTimezone).format('H') < 5 &&
                                        <div className="tooltip">
                                          <span className="tooltip__label" role="presentation" aria-hidden="true">
                                            <i className="icn--title">
                                              <icons.iconMoon />
                                            </i>
                                          </span>
                                          <div id="dates-tooltip" className="tooltip__body" role="tooltip">{translation.very_early}</div>
                                        </div>
                                      }
                                    </h4>
                                    {moment(slot.startDate).tz(userTimezone).format('dddd, MMM DD')}
                                    {slot.data && slot.data.friendlyName &&
                                      <p>{translation.provided_by} {slot.data.friendlyName}</p>
                                    }
                                  </div>
                                  <div className='schedule_items'>
                                    <button
                                      className={`btn--outline media__action ${this.statusClass(slot.startDate)}`}
                                      onClick={() => {
                                        if (slot.data && slot.data.tier >= 0) {
                                          this.selectSlotHybrid(
                                            slot.startDate,
                                            slot.endDate,
                                            slot.data
                                          );
                                        } else {
                                          this.selectSlot(
                                            slot.startDate,
                                            slot.endDate,
                                            slot.proctorLocationSids[0].sid,
                                            slot.proctorLocationSids[0].schedulingModule
                                          );
                                        }
                                      }}
                                    >
                                      {translation.schedule}
                                    </button>
                                    {slot.data && slot.data.tier >= 0 &&
                                      <h6 className='total__header'>{translation.total}: {feeCurrencyFormatter(slot.data.feeInformation.userTotal.toFixed(2), slot.data.feeInformation.currencyCode)}</h6>
                                    }
                                  </div>
                                </div>
                              </li>
                              {this.renderFeeInformation(slot)}
                            </div>
                        )}
                      </ul>
                    }
                    {onlineTimeGroups[group].morning.length === 0 &&
                      <span className="no-results">{translation.no_slots}</span>
                    }
                  </section>
                }

                {((!onlineTimeRange && onlineTimeGroups[group].afternoon.length > 0) || onlineTimeRange === 'afternoon') &&
                  <section className="panel__section block">
                    <h3 className="block__title">{translation.afternoon}</h3>

                    {onlineTimeGroups[group].afternoon.length > 0 &&
                      <ul key={i} className="block-list block-list--alt">
                        {onlineTimeGroups[group].afternoon.map(
                          (slot, j) =>
                          <div>
                            <li key={j} className={`block media--alt space__between ${slot.data && slot.data.feeInformation && slot.data.feeInformation.schedulingRuleInformation && slot.data.feeInformation.schedulingRuleInformation.length > 0 ? 'wrap ' : ''}`}>
                              <div className='schedule_main'>
                                <div className='schedule_details'>


                                  <h4 className="block__title--alt">
                                    {moment(slot.startDate)
                                    .tz(userTimezone)
                                    .format('h:mma')}–{moment(slot.startDate)
                                                        .add(ScheduleStore.examDuration, 'minutes')
                                                        .tz(userTimezone)
                                                        .format('h:mma z')}
                                  </h4>

                                  {moment(slot.startDate).tz(userTimezone).format('dddd, MMM DD')}

                                  {slot.data && slot.data.friendlyName &&
                                    <p>{translation.provided_by} {slot.data.friendlyName}</p>
                                  }
                                </div>

                                <div className='schedule_items'>
                                  <button
                                    className={`
                                    btn--outline
                                    media__action${this.statusClass(slot.startDate)}`}
                                    onClick={() => {
                                      if (slot.data && slot.data.tier >= 0) {
                                        this.selectSlotHybrid(
                                          slot.startDate,
                                          slot.endDate,
                                          slot.data
                                        );
                                      } else {
                                        this.selectSlot(
                                          slot.startDate,
                                          slot.endDate,
                                          slot.proctorLocationSids[0].sid,
                                          slot.proctorLocationSids[0].schedulingModule
                                        );
                                      }}}
                                  >
                                    {translation.schedule}
                                  </button>
                                  {slot.data && slot.data.tier >= 0 &&
                                    <h6 className='total__header'>{translation.total}: {feeCurrencyFormatter(slot.data.feeInformation.userTotal.toFixed(2), slot.data.feeInformation.currencyCode)}</h6> }
                                </div>
                              </div>
                            </li>
                            {this.renderFeeInformation(slot)}
                          </div>
                        )}
                      </ul>
                    }

                    {onlineTimeGroups[group].afternoon.length === 0 &&
                      <span className="no-results">{translation.no_slots}</span>
                    }
                  </section>
                }

                {((!onlineTimeRange && onlineTimeGroups[group].evening.length > 0) || onlineTimeRange === 'evening') &&
                  <section className="panel__section block">
                    <h3 className="block__title">{translation.evening}</h3>
                    {onlineTimeGroups[group].evening.length > 0 &&
                      <ul key={i} className="block-list block-list--alt">
                        {onlineTimeGroups[group].evening.map(
                          (slot, j) =>
                          <div>
                            <li key={j} className={`block media--alt space__between ${slot.data && slot.data.feeInformation && slot.data.feeInformation.schedulingRuleInformation && slot.data.feeInformation.schedulingRuleInformation.length > 0 ? 'wrap ' : ''}`}>
                              <div className='schedule_details'>
                                <h4
                                  className={`
                                    block__title--alt
                                    ${moment(slot.startDate).tz(userTimezone).format('H') > 22 ? 'negative--alt' : ''}
                                  `}
                                >
                                  {moment(slot.startDate)
                                    .tz(userTimezone)
                                    .format('h:mma')}–{moment(slot.startDate)
                                                        .add(ScheduleStore.examDuration, 'minutes')
                                                        .tz(userTimezone)
                                                        .format('h:mma z')}

                                  {moment(slot.startDate).tz(userTimezone).format('H') > 22 &&
                                    <div className="tooltip">
                                      <span className="tooltip__label" role="presentation" aria-hidden="true">
                                        <i className="icn--title">
                                          <icons.iconMoon />
                                        </i>
                                      </span>
                                      <div id="dates-tooltip" className="tooltip__body" role="tooltip">{translation.very_late}</div>
                                    </div>
                                  }
                                </h4>

                                {moment(slot.startDate).tz(userTimezone).format('dddd, MMM DD')}

                                {slot.data && slot.data.friendlyName &&
                                  <p>{translation.provided_by} {slot.data.friendlyName}</p>
                                }
                              </div>

                              <div className='schedule_items'>
                                <button
                                  className={`
                                  btn--outline
                                  media__action
                                  ${this.statusClass(slot.startDate)}
                                `}
                                  onClick={() => {
                                    if (slot.data && slot.data.tier >= 0) {
                                      this.selectSlotHybrid(
                                        slot.startDate,
                                        slot.endDate,
                                        slot.data
                                      );
                                    } else {
                                      this.selectSlot(
                                        slot.startDate,
                                        slot.endDate,
                                        slot.proctorLocationSids[0].sid,
                                        slot.proctorLocationSids[0].schedulingModule
                                      );
                                    }
                                  }}
                                >
                                  {translation.schedule}
                                </button>
                                {slot.data && slot.data.tier >= 0 &&
                                <h6 className='total__header'>{translation.total}: {feeCurrencyFormatter(slot.data.feeInformation.userTotal.toFixed(2), slot.data.feeInformation.currencyCode)}</h6>
                                }
                              </div>
                            </li>
                            {this.renderFeeInformation(slot)}
                          </div>
                        )}
                      </ul>
                    }

                    {onlineTimeGroups[group].evening.length === 0 &&
                      <span className="no-results">{translation.no_slots}</span>
                    }
                  </section>
                }
              </div>
            )}
          </div>
        );
      } else if(ProctorStore.proctors.length > 0 && ProctorStore.proctors[0].location.schedulingModule) {
        if(ProctorStore.proctors[0].location.schedulingModule === 'b-virtual') {
          return (
            <div className={this.props.className}>
              <div className="panel--brief">
                <h2 className="panel__title">{translation.chat.headline}</h2>

                <p>{translation.chat.body}</p>

                <a
                  className="btn"
                  target="_blank"
                  href={`https://spsupport.onlineproctornow.com/api/start_session.ns?issue_menu=1&id=104&customer.name=${SessionStore.profile.firstName}&c2cjs=1`}
                >
                  <icons.iconComment />
                  {translation.chat.chat_button}
                </a>

                <button
                  className="btn btn--outline"
                  onClick={this.refreshSchedule}
                >
                  <icons.iconRefresh />
                  {translation.chat.refresh_button}
                </button>
              </div>
            </div>
          )
        } else {
          return (
            <div className={this.props.className}>
              <div className="panel--brief">
                <h2 className="panel__title">{translation.no_results.headline}</h2>

                <p>{translation.no_results.body}</p>
              </div>
            </div>
          )
        }
      } else {
        return (
          <div className={this.props.className}>
            <div className="panel--brief">
              <h2 className="panel__title">{translation.no_results.headline}</h2>

              <p>{translation.no_results.body}</p>
            </div>
          </div>
        )
      }
    } else {
      return (
        <div className={this.props.className}>
          <span className="loader-bar">Loading…</span>
        </div>
      );
    }
  }
})

export default translate('ScheduleTable')(ScheduleTable);



// WEBPACK FOOTER //
// ./src/app/components/Modules/ScheduleTable.js